var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c("v-card-title", [
        _c("span", { staticClass: "text-h5" }, [_vm._v("Success")])
      ]),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c(
            "v-container",
            { staticClass: "d-flex flex-column justify-content-center" },
            [
              _vm.success
                ? _c("div", { staticClass: "svg-container text-center" }, [
                    _c(
                      "svg",
                      {
                        staticClass: "ft-green-tick",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          height: "100",
                          width: "100",
                          viewBox: "0 0 48 48",
                          "aria-hidden": "true"
                        }
                      },
                      [
                        _c("circle", {
                          staticClass: "circle",
                          attrs: {
                            fill: "#5bb543",
                            cx: "24",
                            cy: "24",
                            r: "22"
                          }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          staticClass: "tick",
                          attrs: {
                            fill: "none",
                            stroke: "#FFF",
                            "stroke-width": "6",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-miterlimit": "10",
                            d: "M14 27l5.917 4.917L34 17"
                          }
                        })
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "mt-4 text-center" }, [
                _vm._v(
                  "\n                " + _vm._s(_vm.message) + "\n            "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "m-4 text-center" },
                [
                  _vm.frontend_view_folder == "frontend.mountain_haus"
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.printReservation()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    Print\n                "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }